import { useEffect } from 'react';

import store from "../../../../store";
import {showWizardInsteadOfQT} from "../../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {switchToWizardItem} from "../../../qkbPages/materialsWizard/useChangeWizardStepRoute";

const useCheckWizardActiveItem = () => {

  useEffect (() => {
    const state = store.getState()
    const {wizardActiveItem, wizardList, wizardIsActive} = state.wizardState;
    if (!wizardActiveItem && showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      switchToWizardItem(null, null, null, null, false); // set default wizard (for sqft)
    }
  }, []);
};

export default useCheckWizardActiveItem;
